import Vue from 'vue'

const $utils = {
    getHostSource () {
        let protocol = window.location.protocol
        let hostname = window.location.hostname
        let port = window.location.port ? ':' + window.location.port : ''
        return protocol + '//' + hostname + port
    },
    copyToClipboard (str, notificationText) {
        const el = document.createElement('textarea')
        el.value = str
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        if (notificationText !== null && notificationText !== undefined) {
            window.vueapp.$appService.toastSuccess(notificationText)
        }
    },
    getFileNameFromUrl (url) {
        let filename = null
        try {
            let lastIndexOf = url.lastIndexOf('/')
            if (lastIndexOf >= 0) {
                filename = url.substring(lastIndexOf + 1)
            }
        } catch (e) {
        }
        if (!filename) {
            filename = 'download'
        }
        return filename
    },
    downloadFileFromUrl (url, filename) {
        // in case current domain is difference from file domain
        // switch to use downloadFileFromUrlAsBlob
        // follow this link for more info:
        // https://stackoverflow.com/questions/23872902/chrome-download-attribute-not-working
        if (!url) {
            return
        }
        if (!filename) {
            filename = this.getFileNameFromUrl(url)
        }
        let a = document.createElement('a')
        a.href = url
        a.setAttribute('download', filename)
        a.click()
    },
    downloadFileFromBlob (data, fileName) {
        const blob = new Blob([data])
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        anchor.click()
        window.URL.revokeObjectURL(url)
    },
    downloadFileFromUrlAsBlob (url, filename) {
        if (!url) {
            return
        }
        if (!filename) {
            filename = this.getFileNameFromUrl(url)
        }
        fetch(url).then(
            result => {
                result.blob().then(blob => {
                    $utils.downloadFileFromBlob(blob, filename)
                })
            }
        )
    },
    isMobile () {
        return window.vueapp.$vuetify.breakpoint.name === 'xs'
    },
    isTablet () {
        return (
            window.vueapp.$vuetify.breakpoint.name === 'sm' ||
            window.vueapp.$vuetify.breakpoint.name === 'md'
        )
    },
    isPC () {
        return (
            window.vueapp.$vuetify.breakpoint.name === 'lg' ||
            window.vueapp.$vuetify.breakpoint.name === 'xl'
        )
    },
    isNotMobile () {
        return !this.isMobile()
    },
    isEqualValue (o1, o2) {
        return JSON.stringify(o1) === JSON.stringify(o2)
    },
    colorSamples: [
        '#87BF40',
        '#7840BF',
        '#BF4078',
        '#40BF87',
        '#B7BF40',
        '#4840BF',
        '#BF6840',
        '#4097BF',
        '#58BF40',
        '#A740BF',
        '#40BF4C'
    ],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    getClientGMT () {
        let offset = new Date().getTimezoneOffset()
        let value = Math.abs(offset / 60)
        value = (value < 10 ? '0' : '') + value
        value = (offset < 0 ? '+' : '-') + value + '00'
        return value
    },
    parseJwt (token) {
        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))

        return JSON.parse(jsonPayload)
    }
}

Vue.prototype.$utils = $utils

export default $utils
